<template>
  <div class="swiper-container">
    <button type="button"
            class="swiper-button-prev btn btn-primary"
            aria-label="Previous"
            role="button"
            v-if="navigation">
      <svg xmlns="http://www.w3.org/2000/svg"
           class="heroicon-svg"
           fill="none"
           viewBox="0 0 24 24"
           stroke="currentColor">
        <path stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M15 19l-7-7 7-7" />
      </svg>
    </button>

    <div class="swiper-wrapper">
      <review-carousel-slide v-for="(slide, index) in slides"
                           :key="`swiper-${inputId}-slide-${index}`"
                           :slide="slide" />
    </div>

    <button type="button"
            class="swiper-button-next btn btn-primary"
            aria-label="Next"
            role="button"
            v-if="navigation">
      <svg xmlns="http://www.w3.org/2000/svg"
           class="heroicon-svg"
           fill="none"
           viewBox="0 0 24 24"
           stroke="currentColor">
        <path stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M9 5l7 7-7 7" />
      </svg>
    </button>

    <div class="swiper-pagination" v-if="pagination"></div>
    <div class="swiper-scrollbar" v-if="scrollBar"></div>
  </div>
</template>

<script>
import Swiper, { Navigation, Pagination, Scrollbar } from 'swiper/core';
import { v4 as uuid } from 'uuid';
import { onMounted } from 'vue';

import ReviewCarouselSlide from './ReviewCarouselSlide.vue';

export default {
  components: { ReviewCarouselSlide },
  name: 'SwiperCarousel',
  props: {
    navigation: {
      type: Boolean,
      default: true,
    },
    pagination: {
      type: Boolean,
      default: false,
    },
    scrollBar: {
      type: Boolean,
      default: false,
    },
    slides: {
      type: Array,
      required: true,
    },
  },
  setup() {
    const inputId = uuid();
    let swiper = undefined;

    const setVisibility = () => {
      if (swiper) {
        swiper.slides.forEach((slide) => {
          if (slide.classList.contains('swiper-slide-active')) {
            slide.tabIndex = 0;
            slide.setAttribute('aria-hidden', 'false');
          } else {
            slide.tabIndex = -1;
            slide.setAttribute('aria-hidden', 'true');
          }
        });
      }
    };

    onMounted(() => {
      Swiper.use([Navigation, Pagination, Scrollbar]);
      swiper = new Swiper('.swiper-container', {
        init: false,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        slidesPerView: 1,
        loop: true,
        autoHeight: true
      });

      swiper.on('init', setVisibility);
      swiper.on('slideChange', setVisibility);

      swiper.init();
    });

    return { inputId };
  },
};
</script>
